import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';


import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-orderfrequency-dropdown',
  templateUrl: './OrderFrequencyDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => OrderFrequencyDropdownComponent)}]
})
export class OrderFrequencyDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getOrderFrequencies().subscribe(x=> this.onGetOrderFrequenciesDone(x));
    }
    
    onGetOrderFrequenciesDone(items: ent.OrderFrequency[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}